export enum ELicencePrintBatchStatus {
  CREATED = '09ca6c0c-b2a8-44fb-ae00-65af4f3374e1',
  SENT = '82a9d563-24a8-462f-ad9f-c23ab676f1e6',
  FAILED_TO_SEND = 'eda41b9e-59ef-449e-817e-b543e143ff89',
  PROCESSED = '3ca322ac-0f2b-4b90-a98e-0eeeccd9cf67',
  REJECTED = '15532ccb-4fd6-4423-a5ea-ffbb6ba4e93c',
  FAILED_RETRY_NEEDED = '7999696e-d9c4-49c1-b157-0854e9468c7f',
}
